export class Widget59DTO {
  microsoft365SecureScore?: boolean;

  microsoftIdentitySecureScore?: boolean;

  microsoftDevicesSecureScore?: boolean;

  microsoftCloudSecureScore?: boolean;

  subscriptionId?: string;

  result?: Widget59ResultDTO;
}

export class Widget59ResultDTO {
  microsoft365SecureScore?: number;

  microsoftIdentitySecureScore?: number;

  microsoftDevicesSecureScore?: number;

  microsoftDevicesExposureScore?: number;

  microsoftCloudSecureScore?: number;

  microsoft365SecureScoreError?: string;

  microsoftIdentitySecureScoreError?: string;

  microsoftDevicesSecureScoreError?: string;

  microsoftDevicesExposureScoreError?: string;

  microsoftCloudSecureScoreError?: string;
}
